import { useStoreSystem } from "../../../store";
import { SideType } from "../../../store/types/store";
import convertDegreesToRadians from "../../../utils/convertDegreesToRadians";

function getAzimuthAngleLimits(currentSide: SideType): { min: number | undefined, max: number | undefined } {
    const proMode = useStoreSystem.getState().proMode;
    switch (currentSide) {
        case "front":
            return {
                min: proMode ? convertDegreesToRadians(270) : convertDegreesToRadians(275),
                max: proMode ? convertDegreesToRadians(90) : convertDegreesToRadians(85)
            }
        case "left":
            return {
                min: convertDegreesToRadians(0),
                max: convertDegreesToRadians(180)
            }
        case "right":
            return {
                min: convertDegreesToRadians(180),
                max: convertDegreesToRadians(0)
            }
        case "back":
            return {
                min: convertDegreesToRadians(90),
                max: convertDegreesToRadians(270)
            }
        case "top":
            return {
                min: undefined,
                max: undefined
            }
    }
}

export default getAzimuthAngleLimits
